import { services } from '../../../common/config/redirects';
import apartmentImg from '@static/icons/Apartment.svg';
import hausImg from '@static/icons/Haus.svg';

import type { Filter } from '@lib/types';

export const GRAPHQL_URL_REMOTE = services.mcCompassApi + '/graphql';
export const GRAPHQL_URL = '/api-mccompass';
export const MAPBOX_ACCESS_TOKEN =
  'pk.eyJ1Ijoia2VrbzkwIiwiYSI6ImNqdWNuNzBkbTBsYnc0ZGx0NG9zYWU0NXUifQ.VDZoKb977dgPkIPhzgOB0Q';
export const MAPBOX_STYLE = 'mapbox://styles/keko90/ckeckts7b2bih19nwmf4nstzy?optimize=true';
export const MAPBOX_IMAGE_BASE_URL =
  'https://api.mapbox.com/styles/v1/keko90/ckeckts7b2bih19nwmf4nstzy/static/';
export const MAX_MAP_SIZE = 1280; // max map image height and width allowed by Mapbox api

export const MAP_LAYERS = {
  polygons: 'polygons',
  properties: 'properties',
  propertiesClustered: 'properties-clustered',
  propertiesClusteredCount: 'properties-clustered-count',
  propertiesClusteredShadow: 'properties-clustered-shadow',
  propertiesClusteredStroke: 'properties-clustered-stroke',
  propertiesUnclustered: 'properties-unclustered',
  propertiesUnclusteredShadow: 'properties-unclustered-shadow',
};

export const COORDINATES_MARGIN = 0.006;

export const ZOOM_LEVELS = {
  country: 6,
  state: 8,
  county: 9,
  city: 12,
  district: 13,
  district_small: 14,
};

export const CLUSTER_MAX_ZOOM = 20;

export const filters: Filter[] = [
  {
    type: 'apartment',
    icon: apartmentImg,
    label: 'Wohnung',
    isDefault: true,
  },
  {
    type: 'house',
    icon: hausImg,
    label: 'Haus',
    isDefault: false,
  },
];
